import {ChangeDetectionStrategy, Component, computed, inject, signal} from '@angular/core';
import {ReactiveFormsModule} from "@angular/forms";
import {BusyService} from "../../services/busy.service";
import {AlertService} from "../../services/alert.service";
import {MAT_DIALOG_DATA, MatDialogClose} from "@angular/material/dialog";
import {Constants} from "../../util/constants";
import {AuthService, TrustedDevice} from "../../services/auth.service";
import {finalize} from "rxjs/operators";
import {MatButton} from '@angular/material/button';
import {MatInput} from '@angular/material/input';
import {MatError, MatFormField} from '@angular/material/form-field';
import {form, FormField, required} from "@angular/forms/signals";
import {FieldErrorsComponent} from "../../controls/field-errors/field-errors.component";

interface DeviceModel {
    alias: string;
}

@Component({
    templateUrl: './device-dialog.component.html',
    styleUrls: ['./device-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ReactiveFormsModule, MatFormField, MatInput, MatError, MatButton, MatDialogClose, FieldErrorsComponent, FormField]
})
export class DeviceDialogComponent {

    device: TrustedDevice = inject(MAT_DIALOG_DATA);
    deviceModel = signal<DeviceModel>({
        alias: this.device.alias
    });
    deviceForm = form(this.deviceModel, (schemaPath) => {
        required(schemaPath.alias, {message: Constants.ERR_REQUIRED});
    });

    constructor(private authService: AuthService,
                private busyService: BusyService,
                private alertService: AlertService) {
    }

    canSubmit =computed(() => {
        // We can submit if the form is valid and the alias name has changed
        return this.deviceForm().valid() && this.deviceModel().alias != this.device.alias;
    });

    submit(event: SubmitEvent) {
        event.preventDefault();
        this.busyService.showBusy();
        this.device.alias = this.deviceModel().alias;
        this.authService.updateTrustedDevice(this.device).pipe(
            finalize(() => {this.busyService.showNotBusy()})
        ).subscribe({
            next: () => {
            },
            error: (err) => {
                this.alertService.error("Error updating device: " + err.message);
                console.error("Error updating device:", err);
            }
        });
    }
}
